import { Component, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { DialogService } from 'src/app/core/dialog.service';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { ListVopRequestParams } from 'src/app/core/vop-request.service';
import { LOCAL_NAVBAR_STATUS_KEY, COLOR_PRIMARY_CONTRAST_500 } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { VopRequestDataComponent } from '../vop-request-data/vop-request-data.component';
import { VopRequestFilterDialogComponent } from '../vop-request-filter-dialog/vop-request-filter-dialog.component';

@Component({
  selector: 'app-vop-request',
  templateUrl: './vop-request.component.html',
  styleUrls: ['./vop-request.component.scss'],
})
export class VopRequestComponent {
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(
    NavigationItemLabel.vop_request,
  );
  filters?: ListVopRequestParams;
  @ViewChild(VopRequestDataComponent) data_component?: VopRequestDataComponent;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private dialog_service: DialogService,
    private meta: Meta,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
  }

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }

  areFiltersSet(): boolean {
    if (!this.filters) return false;

    const active_filters = Object.keys(this.filters).filter(k => {
      if (!this.filters) return false;
      return this.filters[k as keyof typeof this.filters] != null;
    });

    return active_filters && active_filters.length ? true : false;
  }

  onFilterClear(filters: ListVopRequestParams): void {
    this.filters = filters;
    this.setDataFilters();
  }

  setDataFilters(): void {
    if (this.areFiltersSet()) {
      this.data_component?.onFilter(this.filters);
    }

    if (!this.areFiltersSet()) {
      this.data_component?.onFilter();
    }
  }

  onRefresh(): void {
    this.onFilterClear({});
  }

  onFilter(): void {
    this.dialog_service
      .openDialog(VopRequestFilterDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.params) {
          this.filters = dialog_result.params;
          this.setDataFilters();
        }
      });
  }
}
